/**
 * Represents the filter data for a journey list.
 */
export interface JourneyListFilterData {
  /**
   * The start date for filtering journeys (optional).
   */
  startDate?: string;
  /**
   * The end date for filtering journeys (optional).
   */
  endDate?: string;
  /**
   * The status values for filtering journeys.
   */
  status: string[];
}

/**
 * Represents the starting filter data for a journey list.
 */
export interface StartingFilterData {
  /**
   * The start date for filtering journeys (optional).
   */
  startDate?: Date;
  /**
   * The end date for filtering journeys (optional).
   */
  endDate?: Date;
  /**
   * The status values for filtering journeys.
   */
  status: string[];
}

/**
 * Represents the props for a filter component.
 */
export interface FilterProps {
  /**
   * The list of all status options for the filter.
   */
  allStatusList: { label: string, value: string }[];
  /**
   * The initial filter data (optional).
   */
  data?: JourneyListFilterData;
  /**
   * The callback function to apply the filter.
   * @param data - The filter data to apply.
   */
  onApply: (data: JourneyListFilterData) => void;

  /**
   * The callback function to reset the filters.
   */
  onResetFilters: () => void;
}

/**
 * Compares two arrays for equality.
 * @param a - The first array.
 * @param b - The second array.
 * @returns True if the arrays are equal, false otherwise.
 */
export const compareArrays = (a: string[], b: string[]) =>
  a.length === b.length
  && a.every((element, index) => element === b[index]);
